
import React, { useEffect } from "react";
import { Modal, Form, Input, Button, Flex } from "antd";
import InputField from "../../../Reuseable/InputField/InputField";
import CustomSelect from "../../../Reuseable/Select/Select";
import "./EditUserModal.scss";
import NormalButton from "../../../Reuseable/NormalButton/NormalButton";
import { useDispatch, useSelector } from "react-redux";
import { fetchAgencyProducts } from "../../../store/agencySlice";
import { fetchFieldAgents, fetchTeleCallers, fetchTeamLeads } from "../../../store/userRoleSlice";

// const { Option } = Select;

const mapUserDataToFormFields = (userData = {}) => {
  return {
    name: userData?.full_name || "",
    role: userData?.role || "",
    address: userData?.address || "",

    area: Array.isArray(userData?.operational_area)
      ? userData.operational_area.map((a) => a?.id?.toString() || a?.toString())
      : userData?.operational_area
        ? [String(userData.operational_area)]
        : [],

    countryCode: "+91",
    mobile_no: userData?.mobile_no || "",

    product: Array.isArray(userData?.product)
      ? userData.product.map(
        (p) => p?.id?.toString() || p?.products?.toString() || String(p)
      )
      : userData?.product
        ? [String(userData.product)]
        : [],


    telleCaller: Array.isArray(userData?.tele_callers)
      ? userData.tele_callers.map((p) => String(p?.id || p))
      : userData?.tele_callers
        ? [String(userData.tele_callers?.id || userData.tele_callers)]
        : [],

    fieldAgenst: Array.isArray(userData?.field_agents)
      ? userData.field_agents.map((p) => String(p?.id || p))
      : userData?.field_agents
        ? [String(userData.field_agents?.id || userData.field_agents)]
        : [],

    teamLeads: Array.isArray(userData?.team_leads)
      ? userData.team_leads.map((p) => String(p?.id || p))
      : userData?.team_leads
        ? [String(userData.team_leads?.id || userData.team_leads)]
        : [],



    portfolio: Array.isArray(userData?.portfolio)
      ? userData.portfolio.map((p) => p?.id?.toString() || String(p))
      : userData?.portfolio
        ? [String(userData.portfolio)]
        : [],

    bucket: userData?.bucket ? String(userData.bucket) : undefined,
    region: userData?.region ? String(userData.region) : undefined,
    mother_tongue: userData?.mother_tongue
      ? String(userData.mother_tongue)
      : undefined,
    campaign_id: userData?.call_list_id || "",
    agent_id: userData?.tc_id || ""
  };
};

const EditUserModal = ({
  open,
  onClose,
  userData = {},
  onSave,
  data,
  setSelectedUser,
  loading,
  bankData,
  areaCodes,
  isPermissionPage = false,
}) => {
  const { products_list, products_loading } = useSelector(
    (state) => state?.agency
  );

  const {
    // supervisors,
    // supervisors_loading,
    team_leads,
    team_leads_loading,
    field_agents,
    field_agents_loading,
    telecallers,
    telecallers_loading,
  } = useSelector((state) => state?.userRoles);

  const dispatch = useDispatch();
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.setFieldsValue(mapUserDataToFormFields(userData));
    }
  }, [userData, open, form]);


  const telecallerOptions =
    telecallers?.map((item) => ({
      label: item.name,
      value: String(item.id),
    })) || [];

  const fieldAgentOptions =
    field_agents?.map((item) => ({
      label: item.name,
      value: String(item.id)
    })) || [];

  const teamLeadOptions =
    team_leads?.map((item) => ({
      label: item.name,
      value: String(item.id)
    })) || [];

  useEffect(() => {
    if (open) {
      dispatch(fetchAgencyProducts());
      dispatch(fetchTeleCallers());
      dispatch(fetchFieldAgents());
      dispatch(fetchTeamLeads());
    }
  }, [dispatch, open]);

  const handleSave = () => {

    form
      .validateFields()
      .then((values) => {
        const updatedValues = {
          ...values,
          role: values.role,
          area: values.area?.map((id) => Number(id)),
          product: values.product?.map((id) => Number(id)),
          portfolio: values.portfolio?.map((id) => Number(id)),
          bucket: values?.bucket ? Number(values.bucket) : undefined,
          region: values?.region ? Number(values.region) : undefined,
          telleCaller: values?.telleCaller?.map((id) => Number(id)),
          fieldAgenst: values?.fieldAgenst?.map((id) => Number(id)),
          teamLeads: values?.teamLeads?.map(id => Number(id)),
        };
        onSave?.(updatedValues);
      })
      .catch((info) => {
        console.error("Validation Failed:", info);
      });
  };

  const currentRole = Form.useWatch("role", form);

  const isValid = (roles) => {
    const roleList = Array.isArray(roles) ? roles : [roles];
    const roleToCheck = isPermissionPage ? (currentRole || userData?.role) : userData?.role;

    // Normalize strings for comparison (remove spaces, make lowercase)
    const normalizedRoleList = roleList.map(r => r?.replace(/\s/g, "").toLowerCase());
    const normalizedRoleToCheck = roleToCheck?.replace(/\s/g, "").toLowerCase();

    return normalizedRoleList.includes(normalizedRoleToCheck);
  };



  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      closable
      destroyOnClose
      className="editUserModal"
    >
      <h3 className="modalTitle">Edit {userData?.role || "User"}'s Details</h3>
      <Form
        form={form}
        layout="vertical"
        initialValues={mapUserDataToFormFields(userData)}
      >
        <Flex gap={16} wrap="wrap">
          <Form.Item
            name="name"
            className="formItem"
            style={{ flex: 1 }}
            rules={[{ required: true, message: "Please enter the name" }]}
          >
            <InputField label="Name" placeholder="Enter Name" disabled={isPermissionPage} />
          </Form.Item>

          {isPermissionPage && (
            <Form.Item
              name="role"
              className="formItem"
              style={{ flex: 1 }}
              rules={[{ required: true, message: "Please select a role" }]}
            >
              <CustomSelect
                label="Role"
                placeholder="Select Role"
                options={
                  ["teamlead", "telecaller", "fieldagent", "supervisor"].map((roleStr) => {
                    let label = roleStr;
                    if (roleStr === "teamlead") label = "Team Lead";
                    if (roleStr === "fieldagent") label = "Field Agent";
                    if (roleStr === "telecaller") label = "Telecaller";
                    if (roleStr === "supervisor") label = "Supervisor";
                    return {
                      label: label,
                      value: roleStr,
                    };
                  })
                }
              />
            </Form.Item>
          )}

          {!isPermissionPage && (
            <Form.Item
              name="address"
              className="formItem"
              style={{ flex: 1 }}
              rules={[{ required: true, message: "Please enter the address" }]}
            >
              <InputField label="Address" placeholder="Enter Address" />
            </Form.Item>
          )}
        </Flex>

        {!isPermissionPage && (
          <Flex gap={16} wrap="wrap">
            <Form.Item
              name="area"
              className="formItem"
              style={{ flex: 1 }}
              rules={[
                { required: isValid('Telecaller') ? false : true, message: "Please select operational area" },
              ]}
            >
              <CustomSelect
                label="Operational Areas"
                placeholder="Select Area"
                options={areaCodes?.map((area) => ({
                  label: `${area?.areacode}`,
                  value: String(area?.id),
                }))}
                isMultiSelect={true}
              />
            </Form.Item>

            <Form.Item
              label="Mobile Number"
              className="formItem mobileNumWrapper"
              style={{ flex: 1 }}
            >
              <Form.Item
                name="countryCode"
                noStyle
                rules={[{ required: true, message: "Please enter country code" }]}
              >
                <Input style={{ width: 100, marginRight: 8 }} placeholder="+91" />
              </Form.Item>
              <Form.Item
                name="mobile_no"
                noStyle
                rules={[
                  { required: true, message: "Please enter mobile number" },
                ]}
              >
                <InputField placeholder="9999999999" maxLength={10} />
              </Form.Item>
            </Form.Item>
          </Flex>
        )}
        {!isPermissionPage && (
          <Flex gap={16} wrap="wrap">
            <Form.Item
              name="product"
              className="formItem"
              style={{ flex: 1 }}
              rules={[{ required: isValid('Telecaller') ? false : true, message: "Please select product" }]}
            >
              <CustomSelect
                label="Product"
                placeholder="Select Product"
                options={products_list?.results?.map((product) => ({
                  label: product?.products,
                  value: String(product?.id),
                }))}
                isMultiSelect={true}
              />
            </Form.Item>

            <Form.Item
              name="portfolio"
              className="formItem"
              style={{ flex: 1 }}
              rules={[{ required: isValid('Telecaller') ? false : true, message: "Please select bank" }]}
            >
              <CustomSelect
                label="Bank"
                placeholder="Select Bank"
                options={bankData?.map((bank) => ({
                  label: bank?.name,
                  value: String(bank?.id),
                }))}
                isMultiSelect={true}
              />
            </Form.Item>
          </Flex>
        )}




        {
          !isPermissionPage && isValid(['Telecaller']) && (
            <Flex gap={16} wrap="wrap">
              <Form.Item
                name="campaign_id"
                className="formItem"
                style={{ flex: 1 }}
                rules={[{ required: true, message: "Please select Call list id" }]}
              >
                <InputField label="Call list id" placeholder="Enter call list id" />
              </Form.Item>

              <Form.Item
                name="agent_id"
                className="formItem"
                style={{ flex: 1 }}
                rules={[{ required: false, message: "Please select List Agent id" }]}

              >
                <InputField label="Agent id" placeholder="Enter List Agent id" disabled={true} />
              </Form.Item>
            </Flex>
          )
        }



        {isPermissionPage && (
          <Flex gap={16}>
            {
              isValid(['Supervisor', 'Team Lead']) && (
                <Form.Item
                  name="telleCaller"
                  className="formItem"
                  rules={[{ required: false }]}
                >
                  <CustomSelect
                    label="TeleCallers"
                    placeholder="Select"
                    options={telecallerOptions}
                    isMultiSelect={true}
                  />
                </Form.Item>
              )
            }
            {
              isValid(['Supervisor', 'Team Lead', 'Telecaller']) && (
                <Form.Item
                  name="fieldAgenst"
                  className="formItem"
                  rules={[{ required: false }]}
                >
                  <CustomSelect
                    label="Field Agents"
                    placeholder="Select"
                    options={fieldAgentOptions}
                    isMultiSelect={true}
                  />
                </Form.Item>
              )
            }





            {
              isValid(['Supervisor']) && (
                <Form.Item
                  name="teamLeads"
                  className="formItem"
                  rules={[{ required: false }]}
                >
                  <CustomSelect
                    label="TeamLead"
                    placeholder="Select TeamLead"
                    options={teamLeadOptions}
                    isMultiSelect={true}
                  />
                </Form.Item>
              )
            }
          </Flex>
        )}


        {!isPermissionPage && (
          <Flex gap={16} wrap="wrap">
            <Form.Item
              name="bucket"
              className="formItem"
              style={{ flex: 1 }}
              rules={[{ required: isValid('Telecaller') ? false : true, message: "Please select bucket" }]}
            >
              <CustomSelect
                label="Bucket"
                placeholder="Select Bucket"
                options={[1, 2, 3, 4, 5, 6, 7, 8].map((item) => ({
                  label: item,
                  value: item,
                }))}
              />
            </Form.Item>

            <Form.Item
              name="region"
              className="formItem"
              style={{ flex: 1 }}
              rules={[{ required: isValid('Telecaller') ? false : true, message: "Please select region" }]}
            >
              <CustomSelect
                label="Region"
                placeholder="Select Region"
                options={[
                  { value: 1, label: "East Delhi" },
                  { value: 2, label: "West Delhi" },
                  { value: 3, label: "North Delhi" },
                  { value: 4, label: "South Delhi" },
                ]}
              />
            </Form.Item>

            <Form.Item
              name="mother_tongue"
              className="formItem"
              style={{ flex: 1 }}
              rules={[{ required: isValid('Telecaller') ? false : true, message: "Please select language" }]}
            >
              <CustomSelect
                label="Mother Tongue"
                placeholder="Select Language"
                options={[
                  { value: "hindi", label: "Hindi" },
                  { value: "english", label: "English" },
                  { value: "punjabi", label: "Punjabi" },
                ]}
              />
            </Form.Item>
          </Flex>
        )}

        <Form.Item>
          <NormalButton
            type="primary"
            className="saveDetailsBtn"
            onClick={handleSave}
            loading={loading}
          >
            Save Details
          </NormalButton>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditUserModal;
